import { render } from "./BusinessDetails.vue?vue&type=template&id=5c5bdda1"
import script from "./BusinessDetails.vue?vue&type=script&lang=js"
export * from "./BusinessDetails.vue?vue&type=script&lang=js"
script.render = render

export default script